$(document).ready(function(){

    // $(window).scroll(function() {
    //     var scroll = $(window).scrollTop();
    //     if (scroll >= 100) {
    //         $(".animatable").addClass('animated').removeClass('animatable');
    //     } else {
    //         $(".animated").removeClass('animated').addClass('animatable');
    //     }
    // })
})


$(window).scroll(function(){
    var w = $(window).scrollTop();
    // var d = "translateY(" + w*2.25 + "px)";
    var c2 = "translateY(-" + w/0.8 + "px) rotate(22deg)";
    var c1 = "translateY(" + w/0.6 + "px) rotate(-22deg)";
    var c3 = "translateY(" + w/0.75 + "px) rotate(-22deg)";
    var c = "translateY(" + w/2 + "px)";
    var e = "translateY(" + w/1 + "px)";
    var e6 = "translateY(-" + w/1 + "px)";
    // var f = "translateX(" + w*3.75 + "px) translateY(" + w*.75 + "px)";

    // $('.box:first').css({
    //   transform : d
    // });
    $('.line-2').css({
      transform : c2
    });
    $('.line-1').css({
      transform : c1
    });
    $('.line-3').css({
      transform : c3
    });
    $('.line-4').css({
      transform : c
    });
    $('.line-5').css({
      transform : e
    });
    $('.line-6').css({
      transform : e6
    });
    // $('.box.three').css({
    //   transform: f
    // })


    // $('.box:first').find('p').text("1. " + d);
    // $('.box.two').find('p').text("2. " + e);
    // $('.box.three').find('p').text("3. " + f);

});
